import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  ref: "menuRef",
  class: "context-menu-component menu-container"
}
const _hoisted_2 = { class: "ant-menu-light ant-menu-root ant-menu ant-menu-vertical" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-text" }
const _hoisted_5 = { class: "item-shortcut" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "ant-menu-item",
          onClick: ($event: any) => (action.action(_ctx.componentId))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(action.text), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(action.shortcut), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 512))
}